module.exports = __webpack_public_path__ + "static/img/h12.00fc334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h12.jpg
// module id = YgpE
// module chunks = 1